import type { SectionHighlight3 } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionHighlight3['items'];
};

export function BoardSectionTileSmall3Highlight({ boardSectionItems }: Props) {
	const mappedBoardSectionItems = boardSectionItems.map((teaser, index) => {
		return (
			<Tracktor key={teaser.rowId} trackingData={{ data: { inSectionPlacement: index } }}>
				<BoardSectionItem teaser={teaser} isHighlightSection={true} sizes={IMAGE_SIZE_ONE_THIRD} />
			</Tracktor>
		);
	});

	return (
		<BoardSectionTileSection isHighlightSection={true}>
			<BoardSectionTileRow>{mappedBoardSectionItems}</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
